import type { TableColumnSortDirection } from '@percent/lemonade'
import {
  INTERNAL_SERVICE_SORT_FIELDS,
  SERVICE_NAME_MAX_LENGTH,
  type InternalServiceSortField
} from '@percent/admin-dashboard/api/actions/internalServices/internalServices.types'

export const isServiceSortField = (value: string | null | undefined): value is InternalServiceSortField =>
  typeof value === 'string' && (INTERNAL_SERVICE_SORT_FIELDS as readonly string[]).includes(value)

type ServiceListParams = { sort?: string | null; direction?: string | null; search?: string | null }

type ServiceListQuery = { sort: InternalServiceSortField; direction: TableColumnSortDirection; search?: string }

/** The list's query from its URL parameters: anything unknown falls back to by name, ascending, unsearched. */
export const parseServiceListQuery = ({ sort, direction, search }: ServiceListParams): ServiceListQuery => ({
  sort: isServiceSortField(sort) ? sort : 'name',
  direction: direction === 'DESC' ? 'DESC' : 'ASC',
  search: search?.trim().slice(0, SERVICE_NAME_MAX_LENGTH) || undefined
})
